export default function () {
  return {
    downloadTypes: [],
    downloadErrors: [],
    isDownloadLoading: {
      LOAD_ALL: false,
      LOAD_TYPES: false,
      DOWNLOAD: false,
    },
    previewURL: undefined,
  };
}
